// extracted by mini-css-extract-plugin
module.exports = {"name":"WorkSharingInfoItem_name__37V-s","value":"WorkSharingInfoItem_value__2mNbg"};